export default {
    Car: 40,
    Van: 41,
    Bike: 42
}